import { Section, EyebrowHeading } from "../Section";
import type { Audience } from "@/content/audiences";

export function AudienceFAQ({
  audience: a,
  extra = [],
}: {
  audience: Audience;
  /** Extra frågor, t.ex. om foto, som visas efter filmfrågorna. */
  extra?: { q: string; a: string }[];
}) {
  const items = [...a.faq, ...extra];
  return (
    <Section className="bg-surface/40">
      <EyebrowHeading
        eyebrow="Frågor & svar"
        title={`Det vi får frågan om från ${a.label.toLowerCase()}.`}
      />
      <div className="mt-12 mx-auto max-w-3xl divide-y divide-white/10 rounded-3xl border border-white/10 bg-background/40">
        {items.map((f) => (
          <details key={f.q} className="group p-6 md:p-7">
            <summary className="flex cursor-pointer list-none items-start justify-between gap-4 text-base font-semibold md:text-lg">
              <span>{f.q}</span>
              <span className="mt-1 text-mint transition-transform group-open:rotate-45">+</span>
            </summary>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground md:text-base">
              {f.a}
            </p>
          </details>
        ))}
      </div>
    </Section>
  );
}
